import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getContacts } from 'services/ContactService'
import { ContactsRequest } from 'types/contacts'
import { API_PAGINATION_LIMIT, withPaginationPaging } from 'utils/pagination'

export const useContactsQuery = ({
  size = API_PAGINATION_LIMIT,
  page = 0,
  searchQuery = '',
}: ContactsRequest) => {
  return useQuery({
    queryKey: reactQueryKeys.contacts({
      ...(size && { size }),
      ...(page && { page }),
      ...(searchQuery && { searchQuery }),
    }),
    queryFn: () => getContacts({ size, page, searchQuery }),
    select: res => {
      const customerWalletsListWithPagination = withPaginationPaging(res)
      return customerWalletsListWithPagination
    },
  })
}
